import React from "react";
import { Alert } from "react-bootstrap";
import QRCode from "react-qr-code";

export default function KioskDisplay({ community }) {
  if (!community?.id)
    return <Alert variant="warning">Community not loaded.</Alert>;
  // const kioskUrl = `${window.location.origin}/kiosk/${community.id}`;
  const kioskUrl = `${window.location.origin}/community/${community.id}/kiosk`;
  // const kioskUrl = `https://lupie.bigpillar.com/kiosk/${community.id}/kiosk`;
  return (
    <>
      <h5>Community QR (Kiosk)</h5>
      <div className="d-flex flex-column align-items-center">
        <QRCode value={kioskUrl} size={180} />
        <div className="text-muted small mt-1">{kioskUrl}</div>
      </div>
    </>
  );
}
